import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import sanitizeHtml from "sanitize-html";

import { configurationService } from "../../../configuration/ConfigurationService";
import sanitizeOptions from "../../Shared/sanitizeOptions";

const MIN_HEIGHT = 50;

const Preview = ({ data, viewMode }) => {
  const [iframeHeight, setIframeHeight] = useState(MIN_HEIGHT);
  const [isJsEnabled, setIsJsEnabled] = useState(false);
  const previewIframe = useRef(null);

  useEffect(() => {
    const checkIfJsIsEnabled = async () => {
      const response = await configurationService.getEasyHtmlConfiguration();
      const { JSEnablement } = JSON.parse(response.data);
      setIsJsEnabled(JSEnablement);
    };
    checkIfJsIsEnabled();
  }, []);

  const checkAndSanitizeHTML = (dirtyHtml) => {
    if (isJsEnabled) return dirtyHtml;

    return sanitizeHtml(dirtyHtml, sanitizeOptions);
  };

  const output = () => {
    const css = data.codes?.css ? data.codes.css : "";
    const html = data.codes?.html ? data.codes.html : "";
    const js = data.codes?.javascript ? data.codes.javascript : "";

    const sanitizedHtml = checkAndSanitizeHTML(html);

    return `
      <html>
        <head>
          <style>
            html {
              overflow-y: unset !important;
            }
          </style>
          <style>${css}</style>
        </head>
        <body>
          ${sanitizedHtml}
          <script>
            try{
              ${js}
            } catch (e) {}

            (function () {
              // Open all links in new tab.
              var links = document.querySelectorAll("a");

              links.forEach(function (link) {
                link.setAttribute("target", "_blank");
              });

              // Remove <title></title>
              document.querySelector("title").remove();
            })();
          </script>
        </body>
      </html>
    `;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const iframe = previewIframe.current;
      if (iframe) {
        const currentScrollHeight =
          iframe.contentWindow.document.body.scrollHeight;
        if (currentScrollHeight !== iframeHeight) {
          setIframeHeight(currentScrollHeight + MIN_HEIGHT);
        }
      }
    }, 200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="preview-editor"
      style={{
        height: viewMode === "VIEW" ? iframeHeight : "100%",
        width: "100%",
      }}
    >
      <iframe
        title="EasyHtml-Preview"
        srcDoc={output()}
        frameBorder="0"
        scrolling="yes"
        ref={previewIframe}
        height="100%"
        width="100%"
      />
    </div>
  );
};
export default Preview;

Preview.propTypes = {
  data: PropTypes.exact({
    codes: PropTypes.exact({
      css: PropTypes.string,
      html: PropTypes.string,
      javascript: PropTypes.string,
    }),
  }).isRequired,
  viewMode: PropTypes.oneOf(["VIEW", "EDIT"]),
};

Preview.defaultProps = {
  viewMode: undefined,
};
